"use client";

import type { ReactNode } from "react";
import { create } from "zustand";

export type WorkspaceChromeRegistration = {
  title: string;
  titleHref: string | null;
  titleAdornment: ReactNode | null;
  search: ReactNode | null;
  headerAction: ReactNode | null;
  showSubtitle: boolean;
};

type WorkspaceChromeState = WorkspaceChromeRegistration & {
  setWorkspaceChrome: (patch: Partial<WorkspaceChromeRegistration>) => void;
  resetWorkspaceChrome: () => void;
};

const empty: WorkspaceChromeRegistration = {
  title: "",
  titleHref: null,
  titleAdornment: null,
  search: null,
  headerAction: null,
  showSubtitle: true,
};

export const useWorkspaceChromeStore = create<WorkspaceChromeState>((set) => ({
  ...empty,
  setWorkspaceChrome: (patch) => set((s) => ({ ...s, ...patch })),
  resetWorkspaceChrome: () => set(empty),
}));
